/*=========================================================================================
File Name: sidebarItems.js
Description: Sidebar Items list. Add / Remove menu items from here.
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
	// NOTE: Commented for MVP
	// {
	// 	url: "/",
	// 	name: "Dashboard",
	// 	slug: "home",
	// 	svg: "dashboard.svg",
	// 	i18n: "Dashboard",
	// },
	{
		url: "/search-logs",
		name: "Search Logs",
		slug: "search-logs",
		icon: "SearchIcon",
		i18n: "Search Logs",
	},
	{
		url: "/godaddy-logs",
		name: "GoDaddy Logs",
		slug: "godaddy-logs",
		icon: "CheckCircleIcon",
		i18n: "GoDaddy Logs",
	},
	{
		url: "/parent-categories",
		name: "Parent Categories",
		slug: "parent-categories",
		icon: "Share2Icon",
		i18n: "Parent Categories",
	},
	{
		url: "/categories",
		name: "Categories",
		slug: "categories",
		icon: "GridIcon",
		i18n: "Categories",
	},
	{
		url: "/keywords",
		name: "Keywords",
		slug: "keywords",
		icon: "FileTextIcon",
		i18n: "Keywords",
	},
	{
		url: "/prefixes",
		name: "Prefixes",
		slug: "prefixes",
		icon: "SkipBackIcon",
		i18n: "Prefixes",
	},
	{
		url: "/suffixes",
		name: "Suffixes",
		slug: "suffixes",
		icon: "SkipForwardIcon",
		i18n: "Suffixes",
	},
	{
		url: "/curated-names",
		name: "Curated Names",
		slug: "curated-names",
		icon: "StarIcon",
		i18n: "Curated Names",
	},
	{
		url: null,
		name: 'SEO Pages',
		icon: "LayoutIcon",
		i18n: 'SEO Pages',
		submenu: [
			{
				url: '/seo-pages/pages',
				name: 'Page List',
				slug: 'seo-pages.pages',
				i18n: 'Page List'
			},
			{
				url: '/seo-pages/tags',
				name: 'Tagged Names',
				slug: 'seo-pages.tags',
				i18n: 'Tagged Names'
			},
		]
	},
	{
		url: null,
		name: 'Access Control',
		icon: "UsersIcon",
		i18n: 'Access Control',
		submenu: [
			{
				url: '/access-control/users',
				name: 'Users',
				slug: 'access-control.users',
				i18n: 'Users'
			},
			{
				url: '/access-control/roles',
				name: 'Roles',
				slug: 'access-control.roles',
				i18n: 'Roles'
			},
		]
	},
]
